module.exports = __webpack_public_path__ + "static/img/5.eccc52b8.png";